module.exports = __webpack_public_path__ + "static/media/leya.78c6ca72.webp";